var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DevAlarmPop',{ref:"DevAlarmPop",attrs:{"mqttClient":_vm.mqttInfo.client}}),_vm._v(" "),_c('MessageCenterPoptip',{ref:"AdminMessageNotice",attrs:{"mqttClient":_vm.mqttInfo.client,"mqtt-only":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-579be85a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--0-1!./src/components/msgNotice/MqttNotice.vue
// module id = null
// module chunks = 